// German translation
const de = {};

export default de;
